/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isHexString } from 'lorautils/checkers/numbers';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  sent: React.PropTypes.object.isRequired,
};

class RemoveBroadcastReqV2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'devaddr')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    this.setState({ sentStatus: sent.status });
  }

  checkAddr(key, val, errors = this.state.errors) {
    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!isHexString(val, { len: 8 })) {
      return errors.add(
        'FE_INVALIDADDR',
        key,
        { message: this.intlMsg.errorMsg('FE_INVALIDADDR') },
      );
    }
    return errors.remove(key);
  }

  handleChangeDevaddr(e) {
    let val = _.trim(e.target.value);
    val = val.replace(/:|-/g, '');
    let { errors } = this.state;
    errors = this.checkAddr('devaddr', val, errors);
    this.setState({ errors, devaddr: val });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors, devaddr } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    sendCmd(deviceId, {
      devaddr,
    });
  }

  render() {
    const {
      sentStatus = '',
      devaddr = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('devaddr') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.address.label')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={devaddr}
              placeholder={this.intlMsg.msg('addbroadcastreq.devaddr.placeholder')}
              onChange={e => this.handleChangeDevaddr(e)}
            />
            <ControlTips
              show={submitted && errors.has('devaddr')}
              message={this.intlMsg.errorMsg(errors.get('devaddr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

RemoveBroadcastReqV2.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.RemoveBroadcastReqV2,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.RemoveBroadcastReqV2,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RemoveBroadcastReqV2));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/RemoveBroadcastReqV2.jsx